import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TemplateShareControlDialogData, TemplateShareControlDialogResult } from './template-share-control-dialog.model';

@Component({
  standalone: false,
  selector: 'app-template-share-control-dialog',
  templateUrl: './template-share-control-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./template-share-control-dialog.component.scss']
})
export class TemplateShareControlDialogComponent {
  isShared: boolean;
  organizationLevelId: string | null;
  dataOrganizationLevelId: string | null;

  constructor(
    private dialogRef: MatDialogRef<TemplateShareControlDialogComponent, TemplateShareControlDialogResult | null>,
    @Inject(MAT_DIALOG_DATA) public data: TemplateShareControlDialogData
  ) {
    this.isShared = data.isShared;
    this.organizationLevelId = data.organizationLevelId;
    this.dataOrganizationLevelId = data.dataOrganizationLevelId ?? null;
  }

  onShareChange(event: { isShared: boolean; organizationLevelId: string | null }): void {
    this.isShared = event.isShared;
    this.organizationLevelId = event.organizationLevelId;
  }

  confirm(): void {
    this.dialogRef.close({ isShared: this.isShared, organizationLevelId: this.organizationLevelId });
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
